import { z } from 'zod';
import { registrySchema } from '../../../docs/registries';

const REGISTRY_CATALOG_URL = new URL(
  '/registry/index.json',
  process.env.BASE_URL ?? 'http://localhost:3001'
).toString();

const getRegistries = async () => {
  try {
    const response = await fetch(REGISTRY_CATALOG_URL);
    const result = await response.json();
    return z.array(registrySchema).parse(result);
  } catch (error) {
    throw new Error(`Failed to fetch registry from ${REGISTRY_CATALOG_URL}.`);
  }
};

export default getRegistries;
